import { createReducer } from '@reduxjs/toolkit';
import { twitterActions } from '../../actions/twitter';
const initialState = {
    accounts: [],
    meta: {},
    settings: { max_connected_accounts: 3 },
};
export const twitter = createReducer(initialState, (builder) => builder
    .addCase(twitterActions.readAccounts.pending, (state, action) => {
    state.meta.asyncStatusReadAccounts = 'loading';
})
    .addCase(twitterActions.readAccounts.fulfilled, (state, action) => {
    state.accounts = action.payload.data.accounts;
    state.meta.asyncStatusReadAccounts = 'succeeded';
})
    .addCase(twitterActions.readAccounts.rejected, (state, action) => {
    state.meta.asyncStatusReadAccounts = 'failed';
})
    .addCase(twitterActions.getOrganizationSettings.fulfilled, (state, action) => {
    state.settings = action.payload.data;
}));
